import { PrintService } from "../services/print.service"

const printService = new PrintService()

class PrintRealisation {
    printTranscriptDocuments(transcript_id: number, invoice_number: string): Promise<any> {
        return printService.printTranscriptDocuments(transcript_id, invoice_number)
    }

    printLtlMassOrders(params: { orderIds: number[] }): Promise<Blob> {
        return printService.printLtlMassOrders(params)
    }
}

export const printAPI = new PrintRealisation()
